'use strict';

var $ = require('jquery');
var ViewportTracker = require('../lib/ViewportTracker.js');
var Animation = require('../lib/Animation.js');
var detectBrowser = require('../lib/detectBrowser.js');
var AnimationEasing = require('../lib/AnimationEasing.js');

function setupMainMenu() {
    var browserInfo = detectBrowser.getInfo();
    var animationUnsupported = browserInfo.android && browserInfo.androidInfo.versionBrowser == '4.0';

    var config = {
        menu: '#menu',
        menuTarget: '.menu__inner',
        nodeTarget: '.submenu',
        nodeTrigger: '.node--hasSubmenu > a',
        backTarget: '.submenu__back',
        headTarget: '.submenu__heading',
        triggers: '#menuTrigger--open, #menuTrigger--close, #menuOverlay',
        isCollapsable: true,
        isSlidable: false
    };

    var $menu = $(config.menu);
    var $nodeTarget = $menu.find(config.nodeTarget);
    var $menuTarget = $menu.find(config.menuTarget);

    function createBackButton() {
        if ($(config.backTarget).length === 0) {
            var $backButton = $('<div class="submenu__back menu__ribbon"><button>Main Menu</button></div>');
            $nodeTarget.prepend($backButton.clone()).on('click.back', 'button', function() {
                $(this).parents(config.nodeTarget).siblings('a').trigger('click');
            });
        }
    }

    function createHeading() {
        if ($(config.headTarget).length === 0) {
            $nodeTarget.each(function() {
                var text = $(this).siblings('a').text();
                $(this).prepend('<div class="submenu__heading">' + text + '</div>');
            });
        }
    }

    function toggleMenu(event) {
        event.preventDefault();
        $menu.toggleClass('hasMenuOpen');
    }

    function toggleNode(event) {
        event.preventDefault();
        var $eventTarget = $(event.target.tagName == 'SPAN' ? event.target.parentNode : event.target);
        $eventTarget.parent('li').toggleClass('isOpen');
        $menuTarget.toggleClass('hasNodeOpen');
        if (config.isCollapsable) {
            $eventTarget.next().slideToggle(animationUnsupported ? 0 : 400, AnimationEasing.easeOutExpo);
        }
    }

    function setupChildren() {
        if (config.isSlidable) {
            createHeading();
            createBackButton();
        }
        $menu.addClass('hasMenuSetup');
        $nodeTarget.filter('.isActive').parents('li').addClass('isOpen');
        if (config.isCollapsable) {
            $nodeTarget.stop().slideUp().filter('.isActive').slideDown();
        }
        $menuTarget.find('.node--hasSubmenu.node--isActive').parents(config.menuTarget).addClass('hasNodeOpen');
    }

	var eventsAttached = false;

    function attachEvents() {
		if (eventsAttached) {
            return;
        }
        $(config.triggers).on('click', toggleMenu);
        setupChildren();
        $menu.on('click.mobileMenu', config.nodeTrigger, toggleNode);
		eventsAttached = true;
    }

    function detachEvents() {
		if (!eventsAttached) {
            return;
        }
        $(config.triggers).off('click', toggleMenu);
        $menu.removeClass('hasMenuSetup').off('click.mobileMenu');
        $menuTarget.removeClass('hasNodeOpen');
        $nodeTarget.parents('li').removeClass('isOpen').end().stop().slideDown().attr('style', '');
		eventsAttached = false;
    }

    function onViewportState() {
        var state = ViewportTracker.getState();
        $menu.removeClass('hasMenuOpen');
        if (state == 'mobile') {
            attachEvents();
        } else {
            detachEvents();
        }
    }

    onViewportState();
    $(window).on('ViewportTracker:state', onViewportState);
}

var menuVisible = true;
var headerHeight;

function setupStickyMenu() {
    var $header = $('.header');
    if (!$header.length) return;

    var menuStuck;
    var triggerDistance = 200;
    var stuckWhenBelow = $header.offset().top;
    var lastScrollTop = 0;

    function setup(manager) {
        var triggerPoint = Math.max(window.scrollY, stuckWhenBelow);
        headerHeight = undefined;

        manager.addArea(new Animation.AreaCustom('mobile header sticky animation', function(value) {
            if (value > stuckWhenBelow) {
                if (menuStuck !== true) {
                    $header.addClass('header--stuck');
                    menuStuck = true;
                }
            } else if (menuStuck !== false) {
                $header.removeClass('header--stuck');
                menuStuck = false;
            }

            var diff = value - triggerPoint;
            if (Math.abs(diff) >= triggerDistance) {
                triggerPoint = value;
                if (diff > 0) {
                    $header.addClass('header--moveOut');
                    menuVisible = false;
                } else {
                    $header.removeClass('header--moveOut');
                    menuVisible = true;
                }
            }

            // Check scroll direction
            if (value < lastScrollTop) {
                // Scrolling up
                $header.removeClass('header--moveOut');
                menuVisible = true;
            }

            lastScrollTop = value;

            return 0;
        }));
    }

    Animation.Manager.getInstance('scroll--mobile').addSetup(setup);
}

module.exports = {
    init: function() {
        setupMainMenu();
        setupStickyMenu();
    },
    isMenuVisible: function() {
        return menuVisible;
    },
    getHeaderHeight: function() {
        if (headerHeight === undefined) {
            headerHeight = $('.header').outerHeight();
        }
        return headerHeight;
    }
};